import { Button } from "@/components/ui/button";

/**
 * Previous/Next over a server-paged table.
 *
 * Shared by the two admin tables. The legacies one returned all 430 rows and
 * rendered every one of them, which is what kept that tab slow after its query
 * count came down: the work had moved to the browser, not gone away.
 */
export function Pager({
  page,
  pages,
  total,
  noun,
  onPage,
}: {
  page: number;
  pages: number;
  total: number;
  noun: string;
  onPage: (p: number) => void;
}) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <p className="text-muted-foreground text-xs">
        Page {page} of {pages} · {total} {noun}
      </p>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          Previous
        </Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
